import * as Constants from './Constants';

const initialState = {
getAvaialbleplans: null,
getWHWResponse: null,
selectedPlansAndFeatures: null,
cartDetailsVPM: null,
cartDetailsVPMStatus: false,
agreementResponse: null,
agreementAPIStatus: false,
VPMOrderNumber: null,
orderWrireResponse: '',
orderWriteError: null,
orderWritestatus: false,
isWHWDowngradeFlow: false,
initiateCPCAPIError: null,
vpmConfirmationStatus: false,
vpmAccountNumber: null,
vpmMDN: null,
isPlanDowngrade:false,
};

const cpcVPMInspicio = (state = initialState, action) => {
  switch (action.type) {
    case Constants.CPC_AVAILABLE_PLANS: return { ...state, getAvaialbleplans: action.response?.data };
    case Constants.CPC_WHW_ELIGIBLE_RESPONSE: return { ...state, getWHWResponse: action.response?.data };
    case Constants.SELECTED_PLANS_FEATURES: return { ...state, selectedPlansAndFeatures: action.response?.data };
    case Constants.RETRIEVE_CART_VPM_RESPONSE: return { ...state, cartDetailsVPM: action.response?.data };
    case Constants.RETRIEVE_CART_VPM_RESPONSE_STATUS: return { ...state, cartDetailsVPMStatus: action.response };
    case Constants.AGREEMENT_DETAILS_DATA: return { ...state, agreementResponse: action.response?.data.data };
    case Constants.AGREEMENTS_API_SUCCESS: return { ...state, agreementAPIStatus: action.response };
    case Constants.VPM_ORDER_NUMBER: return { ...state, VPMOrderNumber: action.response };
    case Constants.CPC_ORDER_WRITE_RESPONSE: return { ...state, orderWrireResponse: action.response };
    case Constants.CPC_ORDER_WRITE_ERROR: return { ...state, orderWriteError: action.response };
    case Constants.SET_WHW_DOWNGRADE_FLOW: return { ...state, isWHWDowngradeFlow: action.data };
    case 'CPC_ORDER_WRITE_RESPONSE_STATUS': return { ...state, orderWritestatus: action.response };
    case Constants.INIT_JWT_CPC_API_ERROR: return { ...state, initiateCPCAPIError: action.error };
    case Constants.VPM_CONFIRMATION_API: return { ...state, vpmConfirmationStatus: action.response };
    case Constants.VPM_MDN: return { ...state, vpmMDN: action.response };
    case Constants.VPM_ACCOUNT_NUMBER: return { ...state, vpmAccountNumber: action.response };
    case Constants.IS_PLAN_DOWNGRADE: return {
      ...state, isPlanDowngrade: action.data, agreementResponse: null,
      agreementAPIStatus: false,
      
     };
    default: return state;
  }
};
export default cpcVPMInspicio;